import React from 'react';
import { twMerge } from 'tailwind-merge';

interface MockupFrameProps {
  src: string;
  alt: string;
  className?: string;
  perspective?: boolean;
  glow?: boolean;
}

export default function MockupFrame({
  src,
  alt,
  className,
  perspective = false,
  glow = false,
}: MockupFrameProps) {
  return (
    <div
      className={twMerge(
        'relative rounded-xl overflow-hidden',
        perspective && 'transform rotate-y-[-5deg] rotate-x-[2deg]',
        glow && 'glow-orange',
        className
      )}
      style={
        perspective
          ? { transform: 'perspective(1000px) rotateY(-5deg) rotateX(2deg)' }
          : undefined
      }
    >
      {/* Browser chrome */}
      <div className="bg-gray-900 px-4 py-3 flex items-center gap-2">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-red-500" />
          <div className="w-3 h-3 rounded-full bg-yellow-500" />
          <div className="w-3 h-3 rounded-full bg-green-500" />
        </div>
        <div className="flex-1 mx-4">
          <div className="bg-gray-800 rounded-md px-3 py-1 text-xs text-gray-400 text-center">
            xamxamshop.com
          </div>
        </div>
      </div>
      {/* Screenshot */}
      <img
        src={src}
        alt={alt}
        width={1200}
        height={800}
        className="w-full h-auto block"
        loading="lazy"
      />
      {/* Glow effect */}
      {glow && (
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent" />
        </div>
      )}
    </div>
  );
}
